export interface Review {
  id: string;
  dramaId: string;
  user: string;
  rating: number;
  content: string;
  date: string;
  likes: number;
}

export const reviews: Review[] = [
  {
    id: "r-001",
    dramaId: "fengliu-nvguandian",
    user: "长安旧梦",
    rating: 5,
    content:
      "冲着林晚晴来的，结果被苏曼姝整条人物线拿捏了。她不是传统意义上的“大女主”，每一步都带着算计，却又藏着柔软，这种复杂感太难得了。",
    date: "2024-03-21",
    likes: 428,
  },
  {
    id: "r-002",
    dramaId: "fengliu-nvguandian",
    user: "一盏灯",
    rating: 5,
    content:
      "服化道真的用心，满屏的暗红与暖金配色，特别有那个年代的质感。顾廷之和苏曼姝的对手戏，台词都很有嚼头。",
    date: "2024-03-19",
    likes: 361,
  },
  {
    id: "r-003",
    dramaId: "fengliu-nvguandian",
    user: "看剧不睡觉",
    rating: 4,
    content:
      "前半程节奏稍慢，但熬过第五集之后就完全停不下来了。家族线铺得很大，幸好收得住。",
    date: "2024-03-17",
    likes: 205,
  },
  {
    id: "r-004",
    dramaId: "fengliu-nvguandian",
    user: "苏打水加冰",
    rating: 4,
    content: "沈知微这个角色有点意难平，戏份再给多点就好了。不过演员的表现很惊喜。",
    date: "2024-03-15",
    likes: 178,
  },
  {
    id: "r-005",
    dramaId: "fengliu-nvguandian",
    user: "旧报纸",
    rating: 5,
    content:
      "第九集祖母旧信那段，镜头和配乐都封神了。一部剧能让人记住好几个名场面，就已经赢了。",
    date: "2024-03-12",
    likes: 512,
  },
  {
    id: "r-006",
    dramaId: "fengliu-nvguandian",
    user: "冬天晒太阳",
    rating: 3,
    content: "整体不错，就是个别支线有点拖。主线的悬念感还是够的，结局也交代得清楚。",
    date: "2024-03-10",
    likes: 96,
  },
  {
    id: "r-007",
    dramaId: "fengliu-nvguandian",
    user: "夜航船",
    rating: 5,
    content: "陆沉舟演顾廷之太合适了，那种克制到骨子里的深情，全靠眼神在演，很有张力。",
    date: "2024-03-08",
    likes: 389,
  },
  {
    id: "r-008",
    dramaId: "fengliu-nvguandian",
    user: "半盏茶",
    rating: 4,
    content: "商战部分写得比想象中扎实，不是虚张声势，是真的有来有回，看得出编剧做了功课。",
    date: "2024-03-05",
    likes: 143,
  },
  {
    id: "r-009",
    dramaId: "fengliu-nvguandian",
    user: "陈皮糖",
    rating: 2,
    content: "题材是我喜欢的，但个别台词有点“端着”，情感戏还可以再克制一点。",
    date: "2024-03-02",
    likes: 61,
  },
  {
    id: "r-010",
    dramaId: "fengliu-nvguandian",
    user: "雨落屋檐",
    rating: 5,
    content: "二刷之后发现好多细节伏笔，第一遍完全没注意到。值得反复看的好剧。",
    date: "2024-02-28",
    likes: 274,
  },
  {
    id: "r-011",
    dramaId: "jinshang-wangshi",
    user: "江南绣客",
    rating: 5,
    content: "苏锦言的阿锦太灵了，一针一线里都是戏，看完想去学苏绣。",
    date: "2023-09-10",
    likes: 188,
  },
  {
    id: "r-012",
    dramaId: "jinshang-wangshi",
    user: "慢日子",
    rating: 4,
    content: "节奏舒缓但很治愈，适合晚上睡前看两集，画面也特别美。",
    date: "2023-09-08",
    likes: 132,
  },
  {
    id: "r-013",
    dramaId: "yanhuo-nianhua",
    user: "深夜食堂",
    rating: 5,
    content: "每一碗面都看得我饿，母女吵架那场戏太真实了，边看边哭。",
    date: "2024-06-15",
    likes: 246,
  },
  {
    id: "r-014",
    dramaId: "guyun-changan",
    user: "卷子",
    rating: 5,
    content: "群像戏写得好，每个角色都有自己的立场和动机，不是工具人。",
    date: "2024-01-12",
    likes: 301,
  },
  {
    id: "r-015",
    dramaId: "chunfeng-xudu",
    user: "渡口",
    rating: 4,
    content: "很文艺的一部剧，书信那段台词美得像散文，就是有点太慢热了。",
    date: "2023-05-22",
    likes: 97,
  },
  {
    id: "r-016",
    dramaId: "chengshi-dengta",
    user: "守夜人",
    rating: 5,
    content: "救援场面拍得很专业，代入感极强，看完对这群逆行者肃然起敬。",
    date: "2024-08-22",
    likes: 219,
  },
  {
    id: "r-017",
    dramaId: "xingchen-zhixia",
    user: "数星星的人",
    rating: 5,
    content: "青春片里少有的不悬浮，那种对理想的执着很打动人，看完想抬头看看星星。",
    date: "2024-02-16",
    likes: 205,
  },
];